var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockGrad = function SvgLockGrad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f5dd4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "32%",
    stopColor: "#eaf639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f8e71c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M35 22.923H10v21.154h25V22.923zM20.157 40h4.686c.715 0 1.258-.623 1.141-1.307L24.972 32.8l.336-1.308C25.765 29.718 24.384 28 22.5 28s-3.265 1.718-2.808 3.493l.336 1.307-1.012 5.893c-.117.684.426 1.307 1.14 1.307z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M34.805 22.956H10.259V12.718C10.26 5.87 15.765.299 22.532.299c6.767 0 12.273 5.572 12.273 12.419v10.238zm-20.42-4.173H30.68v-6.065c0-4.547-3.655-8.245-8.148-8.245s-8.148 3.698-8.148 8.245v6.065z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M35.938 48H9.126c-1.706 0-3.094-1.404-3.094-3.13V21.913c0-1.726 1.388-3.13 3.094-3.13h26.812c1.706 0 3.094 1.404 3.094 3.13V44.87c0 1.726-1.388 3.13-3.094 3.13zm-25.781-4.174h24.75v-20.87h-24.75v20.87z",
    clipRule: "evenodd"
  })));
};
export default SvgLockGrad;